"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelect = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var useUniqueID_1 = require("../utils/useUniqueID");
var useDescribers_1 = require("../utils/useDescribers");
var Help_1 = require("../InputModules/Help");
var InputBottomRow_1 = require("../InputModules/InputBottomRow");
var SelectModules_1 = require("../SelectModules");
var utils_1 = require("../SelectModules/utils");
var shared_1 = require("../shared");
var helperFunctions_1 = require("../utils/helperFunctions");
var SingleSelect = function (props) {
    var allowItemTextWrap = props.allowItemTextWrap, ariaLabel = props["aria-label"], className = props.className, customRender = props.customRender, error = props.error, guidance = props.guidance, help = props.help, id = props.id, inputHeight = props.inputHeight, initialSelectedItem = props.initialSelectedItem, innerInputRef = props.innerInputRef, innerWrapperRef = props.innerWrapperRef, isAsync = props.isAsync, isDisabled = props.isDisabled, isLoading = props.isLoading, isRequired = props.isRequired, itemIsAnchored = props.itemIsAnchored, itemIsDisabled = props.itemIsDisabled, _a = props.items, items = _a === void 0 ? [] : _a, itemToID = props.itemToID, itemToString = props.itemToString, label = props.label, listboxWidth = props.listboxWidth, maxHeight = props.maxHeight, onBlur = props.onBlur, onChange = props.onChange, onInputChange = props.onInputChange, onInternalStateChange = props.onInternalStateChange, onListboxScroll = props.onListboxScroll, placeholder = props.placeholder, shouldShowAdditionalResultsMessage = props.shouldShowAdditionalResultsMessage, testId = props.testId, units = props.units, value = props.value, restProps = __rest(props, ["allowItemTextWrap", 'aria-label', "className", "customRender", "error", "guidance", "help", "id", "inputHeight", "initialSelectedItem", "innerInputRef", "innerWrapperRef", "isAsync", "isDisabled", "isLoading", "isRequired", "itemIsAnchored", "itemIsDisabled", "items", "itemToID", "itemToString", "label", "listboxWidth", "maxHeight", "onBlur", "onChange", "onInputChange", "onInternalStateChange", "onListboxScroll", "placeholder", "shouldShowAdditionalResultsMessage", "testId", "units", "value"]);
    (0, helperFunctions_1.validateInputLabelAccessibility)('SingleSelect', label, ariaLabel);
    var dropdownWrapperRef = (0, react_1.useRef)(null);
    var singleSelectInnerInputRef = (0, react_1.useRef)(null);
    var selectInputSingleSelectRef = innerInputRef || singleSelectInnerInputRef;
    var uniqueIdSingleSelect = (0, useUniqueID_1.useUniqueId)(id);
    var describersSingleSelect = (0, useDescribers_1.useDescribers)({ help: help, uniqueId: uniqueIdSingleSelect, guidance: guidance });
    var renderItemToStringSingleSelect = itemToString || utils_1.determineItemValue;
    var _b = (0, utils_1.useDetermineFilteredListItems)(), filteredAnchoredItemsCount = _b.filteredAnchoredItemsCount, listItems = _b.listItems, updateFilteredListboxItems = _b.updateFilteredListboxItems;
    var updateFilteredItemsSingleSelect = function (inputText, currentlySelected) {
        if (inputText === void 0) { inputText = inputValue; }
        if (currentlySelected === void 0) { currentlySelected = selectedItem; }
        updateFilteredListboxItems({
            itemIsAnchored: itemIsAnchored,
            items: items,
            itemToID: itemToID,
            renderItemToString: renderItemToStringSingleSelect,
        }, inputText, currentlySelected);
    };
    var clearSelection = function () {
        selectItem(null);
    };
    var safelyCallItemToID = function (item) {
        return (0, utils_1.setupSafelyCallItemToID)(itemToID, renderItemToStringSingleSelect, item);
    };
    var useComboboxControlProps = (0, utils_1.useSingleSelectHooks)({
        initialSelectedItem: initialSelectedItem,
        isDisabled: isDisabled,
        itemIsDisabled: itemIsDisabled,
        listItems: listItems,
        onChange: onChange,
        onInputChange: onInputChange,
        onInternalStateChange: onInternalStateChange,
        renderItemToString: renderItemToStringSingleSelect,
        selectInput: selectInputSingleSelectRef,
        updateFilteredItems: updateFilteredItemsSingleSelect,
    }).useComboboxControlProps;
    var getInputProps = useComboboxControlProps.getInputProps, getItemProps = useComboboxControlProps.getItemProps, getLabelProps = useComboboxControlProps.getLabelProps, getMenuProps = useComboboxControlProps.getMenuProps, getToggleButtonProps = useComboboxControlProps.getToggleButtonProps, highlightedIndex = useComboboxControlProps.highlightedIndex, inputValue = useComboboxControlProps.inputValue, isOpen = useComboboxControlProps.isOpen, openMenu = useComboboxControlProps.openMenu, selectedItem = useComboboxControlProps.selectedItem, selectItem = useComboboxControlProps.selectItem;
    // Update items on initial render and when `items` or `selectedItem` change
    (0, react_1.useEffect)(function () {
        if (items.length) {
            updateFilteredItemsSingleSelect(inputValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items, selectedItem]);
    (0, react_1.useEffect)(function () {
        // re-select current item to cause it to update when items changes
        // since the item's rendered string might have updated e.g. it contains a count
        if (items.length && selectedItem && itemToID && !isAsync) {
            var updatedItem = items.find(function (it) { return itemToID(it) === itemToID(selectedItem); });
            // ensure it still exists in new items list
            if (updatedItem !== selectedItem) {
                selectItem(updatedItem);
            }
        }
    }, [items, selectedItem, itemToID, selectItem, isAsync]);
    // If value prop changes, update selection (as long as value and selected item differ)
    (0, react_1.useEffect)(function () {
        var valueProvided = Object.hasOwn(props, 'value');
        if (valueProvided) {
            if (typeof value === 'object' && typeof selectedItem === 'object') {
                if (safelyCallItemToID(value) !== safelyCallItemToID(selectedItem)) {
                    selectItem(value);
                }
            }
            else if (typeof value === 'string' && typeof selectedItem === 'string') {
                if (value !== selectedItem) {
                    selectItem(value);
                }
            }
            else {
                selectItem(value);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    return (react_1.default.createElement("div", __assign({ className: (0, css_1.cx)(shared_1.inputContainerStyles, shared_1.selectInputContainerStyles, 'ds-single-select'), "data-testid": "".concat(testId, "-container") }, restProps, { ref: innerWrapperRef }),
        react_1.default.createElement("div", { className: shared_1.inputTopRowStyles, "data-testid": "".concat(testId, "-top-row") },
            react_1.default.createElement(Help_1.Help, __assign({ id: uniqueIdSingleSelect, testId: testId || uniqueIdSingleSelect }, help))),
        react_1.default.createElement(SelectModules_1.ComboboxInput, { ariaLabel: ariaLabel, className: className, clearSelection: clearSelection, dropdownWrapperRef: dropdownWrapperRef, describers: describersSingleSelect, error: error, getInputProps: getInputProps, getLabelProps: getLabelProps, getToggleButtonProps: getToggleButtonProps, inputHeight: inputHeight, inputValue: inputValue, isDisabled: isDisabled, isOpen: isOpen, isRequired: isRequired, itemToString: renderItemToStringSingleSelect, label: label, onBlur: onBlur, openMenu: openMenu, placeholder: placeholder, selectedItem: selectedItem, selectInput: selectInputSingleSelectRef, testId: testId || uniqueIdSingleSelect, uniqueId: uniqueIdSingleSelect }),
        react_1.default.createElement(SelectModules_1.ListboxPortal, { allowItemTextWrap: allowItemTextWrap, dropdownWrapperRef: dropdownWrapperRef, customRender: customRender, filteredAnchoredItemsCount: filteredAnchoredItemsCount, filteredItems: listItems, getItemProps: getItemProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, id: uniqueIdSingleSelect, inputValue: inputValue || '', isAsync: isAsync, isDisabled: isDisabled, isLoading: isLoading, isOpen: isOpen, itemIsDisabled: itemIsDisabled, itemToID: itemToID, itemToString: renderItemToStringSingleSelect, listboxWidth: listboxWidth, maxHeight: maxHeight, onListboxScroll: onListboxScroll, selectedItem: selectedItem, shouldShowAdditionalResultsMessage: shouldShowAdditionalResultsMessage, testId: testId || uniqueIdSingleSelect, totalItemCount: items.length }),
        react_1.default.createElement(InputBottomRow_1.InputBottomRow, { error: error, guidance: guidance, id: uniqueIdSingleSelect, isDisabled: isDisabled, testId: testId || uniqueIdSingleSelect, units: units })));
};
exports.SingleSelect = SingleSelect;
exports.SingleSelect.displayName = 'SingleSelect';
